import { Injectable } from '@angular/core';
import { Spesa, TipoSpesa } from 'src/app/common/models/Spesa';
import { SqlAdapterService, SqlStatement } from 'src/app/common/sharedServices/sql/sql-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class SpeseSqlAdapterService {
  // internalID è id univoco che consente di non vincolarsi a aziCdazi + idprodotto + idintervento come chiavi primarie
  private readonly SCHEMA = `(
    internalId INTEGER PRIMARY KEY,

    aziCdazi VARCHAR(3) NOT NULL,
    idProdotto INTEGER NOT NULL,
    codiceProdotto VARCHAR(100),
    descrizioneProdotto VARCHAR(100),

    idIntervento INTEGER,

    oggetto TEXT NOT NULL
  );`;

  private readonly TIPI_SPESA_SCHEMA = `(
    internalId INTEGER PRIMARY KEY,

    idProdotto INTEGER NOT NULL,
    codiceProdotto VARCHAR(100),
    descrizioneProdotto VARCHAR(100)
  );`;

  constructor(private sql: SqlAdapterService) {
    this.initTables();
  }

  private async initTables() {
    let query = `CREATE TABLE IF NOT EXISTS Spese ${this.SCHEMA}`;
    try {
      const created = await this.sql.execute({
        statement: query,
      });
      console.log('Created table Spese ? ', created);
    } catch (error) {
      console.error('Errore while creating table Spese', error);
    }

    query = `CREATE TABLE IF NOT EXISTS TipiSpese ${this.TIPI_SPESA_SCHEMA}`;
    try {
      const created = await this.sql.execute({
        statement: query,
      });
      console.log('Created table TipiSpese ? ', created);
    } catch (error) {
      console.error('Errore while creating table TipiSpese', error);
    }
  }

  async inserisciSpese(spese: Spesa[]) {
    const insertQueries = spese.map(spesa => this.getSingleInsertQuery(spesa));
    try {
      const inserted = await this.sql.executeSet(insertQueries);
      console.log('Inserted into table Spese ? ', inserted);
    } catch (error) {
      console.error('Errore while inserting data into table Spese', error);
    }
  }

  async inserisciTipiSpese(tipiSpesa: TipoSpesa[]) {
    const insertQueries = tipiSpesa.map(ts => this.getSingleTypeInsertQuery(ts));
    try {
      const inserted = await this.sql.executeSet(insertQueries);
      console.log('Inserted into table TipiSpese ? ', inserted);
    } catch (error) {
      console.error('Errore while inserting data into table TipiSpese', error);
    }
  }

  private getSingleInsertQuery(spesa: Spesa): SqlStatement {
    const query = `INSERT INTO Spese (aziCdazi, idProdotto, codiceProdotto, descrizioneProdotto, idIntervento, oggetto) VALUES (?, ?, ?, ?, ?, ?)`;
    return {
      statement: query,
      values: [
        spesa.aziCdazi, spesa.idProdotto, spesa.codiceProdotto,
        spesa.descrizioneProdotto, spesa.idIntervento, JSON.stringify(spesa)]
    };
  }

  private getSingleTypeInsertQuery(tipoSpesa: TipoSpesa): SqlStatement {
    const query = `INSERT INTO TipiSpese (idProdotto, codiceProdotto, descrizioneProdotto) VALUES (?, ?, ?)`;
    return {
      statement: query,
      values: [
        tipoSpesa.idProdotto, tipoSpesa.codiceProdotto, tipoSpesa.descrizioneProdotto]
    };
  }

  async updateSpesa(spesa: Spesa) {
    //FIX ME: facendo l'update così non posso avere più righe con la stessa spesa
    const query = `UPDATE Spese SET oggetto = ? WHERE (idIntervento = ? AND idProdotto = ? AND aziCdazi = ? ;`;
    try {
      const updated = await this.sql.execute({
        statement: query,
        values: [JSON.stringify(spesa), spesa.idIntervento, spesa.idProdotto, spesa.aziCdazi]
      });
      console.log('Update existing spesa  ? ', updated);
    } catch (error) {
      console.error('Errore while updating data from table Spese', error);
    }
  }

  async rimuoviSpese() {
    const query = `DELETE FROM Spese ;`;
    try {
      const removed = await this.sql.execute({
        statement: query
      });
      console.log('Removed all Spese bound to operations ? ', removed);
    } catch (error) {
      console.error('Errore while removing from table Spese', error);
    }
  }

  async rimuoviTipiSpese() {
    const query = `DELETE FROM TipiSpese ;`;
    try {
      const removed = await this.sql.execute({
        statement: query
      });
      console.log('Removed all TipiSpese bound to operations ? ', removed);
    } catch (error) {
      console.error('Errore while removing from table TipiSpese', error);
    }
  }

  async fetchSpeseOffline(idIntervento: number): Promise<Spesa[]> {
    const selectField = `SELECT idIntervento, oggetto FROM Spese WHERE (idIntervento = ? ); `;
    try {
      const records = await this.sql.execute({
        statement: selectField,
        values: [idIntervento]
      });

      const result = [];
      for (let k = 0; k < records.values.length; k++) {
        result.push(records.values[k]);
      }
      console.debug('Select spese result', result);
      return result.map(row => JSON.parse(row.oggetto));
    } catch (error) {
      console.error('Errore while selecting data from table Spese', error);
      return [];
    }
  }

  async fetchTipiSpeseOffline(): Promise<TipoSpesa[]> {
    const selectField = `SELECT idProdotto, codiceProdotto, descrizioneProdotto FROM TipiSpese ; `;
    try {
      const records = await this.sql.execute({
        statement: selectField,
      });
      const result = [];
      for (let k = 0; k < records.values.length; k++) {
        result.push(records.values[k]);
      }
      console.debug('Select Tipispese result', result);
      return result;
    } catch (error) {
      console.error('Errore while selecting data from table TipiSpese', error);
      return [];
    }
  }
}